import { useQuery, UseQueryOptions } from 'react-query';

import {Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomAccessQuery (
	guid: Guid | undefined,
	options?: Omit<UseQueryOptions<boolean, unknown, boolean, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.LenderNda.Access(guid),
		() =>
			AxiosUtils.getResponseData<boolean>(
				api.get(CerebroApiEndpoints.LenderNda.Access(guid))
			),
		options
	);
}
